if (!customElements.get("readmore-element")) {
  customElements.define(
    "readmore-element",
    class ReadmoreElement extends HTMLElement {
      constructor() {
        super();
        this.options = {
          readmoreTrigger: "[data-readmore-trigger]",
          readmoreLabel: "[data-readmore-label]",
          readmoreContent: "[data-readmore-content]",
          collapsedHeight: "140px",
          openClass: "open",
        };
        this.trigger = this.querySelector(this.options.readmoreTrigger);
        this.content = this.querySelector(this.options.readmoreContent);
        this.label = this.querySelector(this.options.readmoreLabel);
        this.isOpen = false;
        this.registerEvents();
      }

      registerEvents() {
        this.trigger.addEventListener("click", () => this.toggle());
      }

      toggle() {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
          // Stel max-height in op de werkelijke hoogte voor een vloeiende animatie
          this.content.style.maxHeight = this.content.scrollHeight + "px";
          this.content.setAttribute("aria-expanded", "true");
          this.trigger.setAttribute("aria-expanded", "true");
          this.label.textContent = this.trigger.dataset.labelLess
          this.classList.add(this.options.openClass);
        } else {
          this.content.style.maxHeight = this.options.collapsedHeight;
          this.content.setAttribute("aria-expanded", "false");
          this.trigger.setAttribute("aria-expanded", "false");
          this.label.textContent = this.trigger.dataset.labelMore;
          this.classList.remove(this.options.openClass);
        }
      }
    }
  );
}